module.exports = __webpack_public_path__ + "img/wrif-grey.5cd5030.svg";